
























































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { default as QuestionVue } from "./question";
import { QuestionMatrixModel } from "survey-core";

@Component
export class Matrix extends QuestionVue<QuestionMatrixModel> {
  cellClick(row: any, column: any) {
    row.value = column.value;
  }
}
Vue.component("survey-matrix", Matrix);
export default Matrix;
